import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Modal, Button, Divider } from 'rsuite';
import differenceInDays from 'date-fns/differenceInDays';

export default function CancellationtDialogView ({ cancellation, show, onHide }) {
    // State

    // Loading state
    const [isLoading, setIsLoading] = useState(true);

    // Functions

    const prepareCancellation = () => {
        setIsLoading(true);

        cancellation.diffDays = differenceInDays(new Date(), moment(cancellation.created_at).toDate());
        cancellation.diffDaysText = !cancellation.diffDays ? 'Hoy' : `Hace ${cancellation.diffDays} día${cancellation.diffDays > 1 ? 's' : ''}`;
        setIsLoading(false);
    };

    // Events

    // if !cancellation we should close modal
    useEffect(() => {
        if (!cancellation) {
            onHide();
            return;
        }

        prepareCancellation();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cancellation]);

    // Main Component

    return (
        <Modal
            open={show}
            onClose={onHide}
            className={`${show ? 'show in' : ''}`}
            aria-labelledby='cancellation-confirm-modal'
        >
            <Modal.Header closeButton>
                <Modal.Title id='cancellation-confirm-modal'>
                    {!isLoading && (
                        <>
                            <span>{`Baja de cliente - ${cancellation.formattedName || ''}`}</span>
                            <br/>
                            <div className='mt-2'><small>{cancellation.diffDaysText}</small></div>
                        </>
                    )}
                    {isLoading && <span>Cargando...</span>}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {!isLoading && (
                    <>
                        <Divider />
                        <div className='row text-dark mt-3'>
                            <div className='col-12'>
                                <b>Email de usuario</b>:&nbsp;
                                <span>{cancellation.email.description}</span>
                            </div>
                        </div>
                        <Divider />
                        <div className='row text-dark'>
                            <div className='col-12'>
                                <b>Razon de Baja</b>:&nbsp;
                                <span>{cancellation.metadata.reason}</span>
                            </div>
                        </div>
                        <Divider />
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <div>
                    <Button disabled={isLoading} appearance='subtle' onClick={onHide} >Aceptar</Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
}
